import { Address } from "@/types"
import { createContext, useContext } from "react"

export type CheckoutContextValue = {
  addresses: Address[]
  hasExtras: boolean
  /** True when the customer arrived via a QR-table URL (?table=<uuid>). */
  isTableOrder: boolean
  /** The resolved table display name (e.g. "Mesa 3"). Empty string in normal mode. */
  tableName: string
  /** The table UUID from the QR slug. Empty string in normal mode. */
  tableId: string
  /** The table's PDV/POS external code, when configured. Empty string in normal mode or when unset. */
  tableExternalCode: string
}

export const CheckoutContext = createContext<CheckoutContextValue | null>(null)

export function useCheckoutContext(): CheckoutContextValue {
  const ctx = useContext(CheckoutContext)
  if (!ctx) throw new Error("useCheckoutContext must be used within CheckoutLayout")
  return ctx
}
